var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16430_70146)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.666667C0 0.298477 0.298477 0 0.666667 0H11C11.3682 0 11.6667 0.298477 11.6667 0.666667V5H10.3333V1.33333H1.33333V10.3333H5V11.6667H0.666667C0.298477 11.6667 0 11.3682 0 11V0.666667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3359 4.9987C10.3359 4.63051 10.6344 4.33203 11.0026 4.33203H15.3359C15.7041 4.33203 16.0026 4.63051 16.0026 4.9987V15.332C16.0026 15.7002 15.7041 15.9987 15.3359 15.9987H5.0026C4.63441 15.9987 4.33594 15.7002 4.33594 15.332V10.9987C4.33594 10.6305 4.63441 10.332 5.0026 10.332H10.3359V4.9987ZM11.6693 5.66536V10.9987C11.6693 11.3669 11.3708 11.6654 11.0026 11.6654H5.66927V14.6654H14.6693V5.66536H11.6693Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16430_70146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.c20f3592b3a1f6086862bb0fc449a81a.svg";
export { ForwardRef as ReactComponent };